import { FC, memo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { CopayClaimsData } from "src/pages/actionDashboard/types";
import ManufacturerNextStepActions from "../manufactureNextStepActions";
import { isMobileOrTablet } from "src/helpers";
import { useOnClickOutside } from "src/hooks/useClickOutside";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

type Props = {
  row: CopayClaimsData;
  refreshListing: () => void;
  index: number
};

const CopayBucketTableRow: FC<Props> = ({ row, refreshListing, index }) => {
  const toggleIconRef = useRef<HTMLElement | null>(null);
  const [infoIconIndex, changeInfoIconIndex] = useState<number>(-1);

  useOnClickOutside(toggleIconRef, () => {
    changeInfoIconIndex(-1);
  });
  console.log("CopayBucketTableRow...")
  return (
    <tr>

      <td className="text-center align-middle">
        <Link
          to={`/global_patients/${row.patient_id}`}
          className={`${row.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {row.patient_id}
        </Link>
      </td>
      <td className="text-center align-middle">
        <Link
          to={`/cases/detail/${row.bi_case_id}`}
          className={`${row.drug_name === "iovera°" ? 'text-iovera' : 'text-zilretta'} `}
        >
          {row.bi_case_id}
        </Link>
      </td>
      {/* <td className="text-center align-middle">
        {row.drug_name === "iovera°" ? row.drug_name : row.drug_name.toUpperCase()}

      </td>
      <td className="text-center align-middle">
        {row.bi_submitted && format(row.bi_submitted, "MM/dd/yyyy")}
      </td> */}
      <td className="text-center align-middle">
        {row.bi_completed && format(row.bi_completed, "MM/dd/yyyy")}
      </td>
      <td className="text-center align-middle">
        {row.date_of_service}
      </td>
      <td className="text-center align-middle">
        {row.insurance_name}
      </td>
      <td className="text-center align-middle">
        {row && row.practice && row.practice.name}
      </td>
        <td className="text-center align-middle">
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip className="custom-tooltip">
                            {row && row.practice &&(
                                <>
                                    <p><strong>Practice Name:</strong> {row.practice.name}</p>
                                    <p><strong>Address:</strong> {row.practice.address}</p>
                                    <p><strong>Phone:</strong> {row.practice.phone_number}</p>
                                    <p><strong>Fax:</strong> {row.practice.fax_number}</p>
                                </>
                            )}
                        </Tooltip>
                    }
                >
                      <span
                          className="text-link text-blue link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover">
                        {row.provider}
                      </span>
                </OverlayTrigger>
            </>
        </td>
      <td className="text-center align-middle">
        {row.copay_status}
      </td>
      <td
        className={`text-center align-middle ${row.days_until_copay_claim_filed < 40 ? "text-danger" : ""
          }`}
      >
        {row.days_until_copay_claim_filed ?? "N/A"}
      </td>

      {/* <td className="text-center align-middle">
        {row.drug_name === "iovera°" ? row.drug_name : row.drug_name.toUpperCase()}

      </td>
      <td className="text-center align-middle">
        {row.bi_submitted && format(row.bi_submitted, "MM/dd/yyyy")}
      </td> */}


      {/* <td className="text-center align-middle">
      <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
      </td> */}

      {/* Pharmacy Coverage */}


      {/* <td className="text-center align-middle">
        {row.patient_name !== "Redacted" ? (
          <Link to={`/global_patients/${row.patient_id}`}>
            {row.patient_name}
          </Link>
        ) : (
          row.patient_name
        )}
      </td>
      <td className="text-center align-middle">
        {row.insurance_type}
      </td>
      {/* Medical Coverage */}
      {/* <td className="align-middle">
        <span className={`badge background-color-${row.medical_coverage_status_color}`}>
          {row.medical_coverage_status}
        </span>
      </td>
      <td className="align-middle">
        <span className={`badge background-color-${row.pharmacy_coverage_status_color}`}>
          {row.pharmacy_coverage_status}
        </span>
      </td>
      <td className="text-center align-middle">
      {/* <ManufacturerNextStepActions refreshListing={refreshListing} kase={row} next_steps={row.next_steps}/>
      </td> */}
    </tr>
  );
};

export default memo(CopayBucketTableRow);
